import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { SubscriptionResponse } from "@/types/generated/cms.generated";

/**
 * An organisation's subscriptions (CMS API `GET /subscriptions/organization/{organizationId}`) —
 * the "Plan & seats" card on the company page's Overview. Idle without an id.
 */
export const orgSubscriptionsKey = (organizationId: string | null | undefined) =>
  ["organizations", organizationId, "subscriptions"] as const;

export function useOrgSubscriptions(organizationId: string | null | undefined) {
  return useQuery<SubscriptionResponse[]>({
    queryKey: orgSubscriptionsKey(organizationId),
    queryFn: () => apiRequest<SubscriptionResponse[]>("GET", `/subscriptions/organization/${organizationId}`),
    enabled: !!organizationId,
  });
}

const startTime = (s: SubscriptionResponse) => {
  const t = s.startDate ? Date.parse(s.startDate) : NaN;
  return Number.isNaN(t) ? -Infinity : t;
};

/** The plan shown: the subscription with `isActive: true`; with several, the latest `startDate`. None ⇒ null. */
export function activeSubscription(rows: SubscriptionResponse[] | null | undefined): SubscriptionResponse | null {
  const active = (rows ?? []).filter((s) => s.isActive === true);
  if (active.length === 0) return null;
  return active.reduce((latest, s) => (startTime(s) > startTime(latest) ? s : latest));
}
